import { defineAsyncComponent } from 'vue'
export default {
  agri: defineAsyncComponent(() => import("/builds/b2ag/fronts/front-b2ag/front/core/app/layouts/agri.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/builds/b2ag/fronts/front-b2ag/front/core/app/layouts/empty.vue").then(m => m.default || m)),
  minimal: defineAsyncComponent(() => import("/builds/b2ag/fronts/front-b2ag/front/core/app/layouts/minimal.vue").then(m => m.default || m)),
  tech: defineAsyncComponent(() => import("/builds/b2ag/fronts/front-b2ag/front/core/app/layouts/tech.vue").then(m => m.default || m))
}